<div class="bottom-cart-n-checkout d-flex justify-content-center">
  <cart-btn-quantity-price
    class="me-3"
    [size]="'lg'"
  ></cart-btn-quantity-price>

  <button class="btn {{checkoutBtnColor}} flex-grow-1 cart-footer-checkout-btn"
          [translate]="'orderProcess.cakesOverview.goToCheckout'"
          (click)="onCheckout.emit()">
    Go to checkout
  </button>
</div>
